function noop(any) {
    return any;
}

export { noop };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/noop.js
// module id = 191
// module chunks = 0